export const role = () => {
  return getRole('/back/v1/common/roles')
}
export const dpt = () => {
  return getRole('/back/v1/dpt/list')
}
export const grp = () => {
  return getRole('/back/v1/cg/list')
}
function getRole(url: string) {
  // @ts-ignore
  let apiArr = JSON.parse(sessionStorage.getItem('MENU'))
  let bool = false
  // @ts-ignore
  apiArr.forEach(item => {
    if (url === item.path) {
      bool = true
    }
  })
  return bool
}